(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fan-vouchers"] && !Shopify.designMode) return;
  try {
    
  function updateVoucherCharacterCounter(field) {
    const counter = field.closest('label')?.querySelector('[data-voucher-character-counter]');
    if (counter) counter.textContent = `${field.value.length} / ${field.maxLength}`;
  }

  document.querySelectorAll('[data-voucher-personalization-field]').forEach(updateVoucherCharacterCounter);
  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-voucher-personalization-field]')) {
      updateVoucherCharacterCounter(event.target);
    }
  });

  function openLinkedVoucher() {
    const voucher = document.getElementById(window.location.hash.slice(1));
    if (!voucher || !voucher.matches('.fan-product')) return;

    const details = voucher.querySelector('.fan-product__details');
    if (details) details.open = true;
  }

  openLinkedVoucher();
  window.addEventListener('hashchange', openLinkedVoucher);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
